import React, { useEffect } from "react";
import "./Tabs.css";

interface TabItem {
  id: string;
  name: string;
  identifier: string;
  icon?: string;
  number?: number | string;
}

interface TabsProps {
  tabs: TabItem[];
  onContentToggle: (selectedTabId: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ tabs, onContentToggle }) => {
  const toggleTabHandler = (e: React.MouseEvent<HTMLSpanElement>) => {
    const selectedTab = e.currentTarget.id;
    const identifier = document
      .getElementById(selectedTab)
      ?.getAttribute("data-group");

    if (!identifier) return;

    const tabElements = document.querySelectorAll(`.${identifier}`);

    tabElements.forEach((tab) => tab.classList.remove("active"));
    document.getElementById(selectedTab)?.classList.add("active");

    onContentToggle(selectedTab);
  };

  // Enable first active tab
  const enableActiveTab = (identifier?: string) => {
    if (!identifier) return;
    const tabs = document.querySelectorAll(`.${identifier}`);
    tabs[0]?.classList.add("active");
  };

  // componentDidMount + componentDidUpdate equivalent
  useEffect(() => {
    const identifier = tabs[0]?.identifier;
    enableActiveTab(identifier);
  }, [tabs]);

  return (
    <div className="Tabs animated speed-1x fadeInRight">
      <div className="tabs__wrapper">
        {tabs.map((tab) => {
          let TabSymbol: React.ReactNode = null;

          if (tab.icon) {
            TabSymbol = <i className={tab.icon} />;
          } else if (tab.number) {
            TabSymbol = <span className="round">{tab.number}</span>;
          }

          return (
            <span
              className={`${tab.identifier} filterItem`}
              data-group={tab.identifier}
              key={tab.id}
              id={tab.id}
              onClick={toggleTabHandler}
            >
              {TabSymbol}
              {tab.name}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
